export enum OrderType {
    Delivery,
    Pickup,
    DineIn
}

export function orderTypeToString(type: OrderType): string {
    switch (type) {
        case OrderType.Delivery:
            return "Dostava";
        case OrderType.Pickup:
            return "Preuzimanje";
        case OrderType.DineIn:
            return "Usluživanje u lokalu";
        default:
            return "Nepoznat tip porudžbine";
    }
}